/**
 * 大玩家接口
 * 
 * @author 杨斌
 * @since 2019-09-24
 */
import common from './common'
import store from './store'

var ApiList = {};

//API 接口


/**
 * 获取话费直充开关
 */
ApiList.getPhoneChargeEnable = function (okCb, failCb) {
    var p = {}
    common.Api('/customer/api/phoneCharge/isEnabled.json', p, okCb, failCb)
}

/**
 * 获取话费直充商品列表
 */
ApiList.getProductList = function (okCb, failCb) {
    var p = {}
    common.Api('/customer/api/phoneCharge/productList.json', p, okCb, failCb)
}

/**
 * 获取默认手机号码
 */
ApiList.getDefaultPhone = function (okCb, failCb) {
    var p = {}
    common.Api('/customer/api/phoneCharge/defaultPhone.json', p, okCb, failCb)
}


/**
 * 话费充值
 */
ApiList.handleCharge = function (phone, pricePoint, productId,okCb, failCb) {
    var p = {
        phone,
        pricePoint,
        productId
    }
    common.Api('/customer/api/phoneCharge/charge.json', p, okCb, failCb)
}

/**
 * 话费充值
 */
ApiList.getRecord = function (lastId, okCb, failCb) {
    var p = {
        lastId,
        limit: 10
    }
    common.Api('/customer/api/phoneCharge/recordList.json', p, okCb, failCb)
}

/**
 * 话费充值详情
 */
ApiList.getDetail = function (orderno, okCb, failCb) {
    var p = {
        orderno,
    }
    common.Api('/customer/api/phoneCharge/recordDetail.json', p, okCb, failCb)
}

export default ApiList;


// WEBPACK FOOTER //
// ./src/api/charge-api.js